<template>

<core-dropdown class="input" trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick">

	<core-button v-on:click.native="onToggleClick" tooltip="Manage layout" theme="filter" :icon="icon" :iconOnly="true" />
	
	<core-dropdown-list class="input-options" theme="filter" :caret="true" align="left" type="button">

		<core-dropdown-item v-for="layout in layouts" :icon="layout.icon" :key="layout.value" type="action" v-bind:class="{'is-active': value === layout.value}" v-on:click.native="onOptionClick(layout.value)">{{ layout.name }}</core-dropdown-item>

		<slot></slot>

	</core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'filter', 'page'
	],
	
	data: function() {

		return {
			is: {
				expanded: false
			}
		}

	},

	computed: {

		layouts: function() {

			if (this.page === 'collection') return this.$CONSTANTS.LAYOUT.OPTIONS.COLLECTION 
			if (this.page === 'lists') return this.$CONSTANTS.LAYOUT.OPTIONS.LISTS 
			if (this.page === 'plays') return this.$CONSTANTS.LAYOUT.OPTIONS.PLAYS 
			if (this.page === 'ratings') return this.$CONSTANTS.LAYOUT.OPTIONS.RATINGS 

			return false

		},

		icon: function() {

			return this.$_.findWhere(this.layouts, {
				value: this.value
			}).icon

		},

		value: function() {

			return this.$store.getters['filter/' + this.filter]

		}

	},

	methods: {

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		},

		onOptionClick: function(value) {

			this.$store.commit('filter/' + this.filter, value)

			this.is.expanded = false

		}

	}

}

</script>

<style scoped>

.is-desktop .input-options,
.is-tablet .input-options {
	right: 0px;
	top: 64px!important;
	padding: 5px 0px;
	background-color: #2b5870;
	border-radius: 0px 0px 4px 4px;
	box-shadow: 0 7px 29px 0 rgba(100, 100, 111, .2);
}

</style>
